module.exports = fox._r("images/logout.png", __webpack_public_path__ + "images/logout.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/logout.png
// module id = 1080
// module chunks = 4